module.exports = __webpack_public_path__ + "img/hino.06a77cd6.svg";